import { ROUTE } from "../Interface/interface";

export const getAcceptAttribute = (urlType: string): string => {
    if (urlType === ROUTE.JSON_PARSER || urlType === ROUTE.JSON_FORMATOR) {
      return "json";
    } else if (urlType === ROUTE.HTML_FORMATOR) {
      return "html";
    } else if (urlType === ROUTE.CSS_FORMATOR) {
      return "css";
    }
    // Default case, return an empty string or another default value if needed
    return "";
};

export const printLogs = (name: string, value: any) => {
  if (typeof window !== 'undefined')
    if (window.location.href.includes('localhost')) {
      console.log(name, value);
    }
};